const isTrue = (v: unknown) => v === true || v === 1 || v === '1' || v === 'true'

export function spansAllWorkspaces(m: any): boolean {
  if (!m) return false
  return (
    isTrue(m.is_organization_owner) ||
    isTrue(m.is_super_admin) ||
    (String(m.role || '').toUpperCase() === 'ADMIN' && !isTrue(m.is_agency))
  )
}

export function memberWorkspaceIds(m: any): string[] {
  const accounts = Array.isArray(m?.assigned_accounts) ? m.assigned_accounts : []
  return accounts.map((a: any) => a?.workspace_id ?? a?.id).filter(Boolean)
}

export function isWorkspaceMember(m: any, workspaceId: string | null | undefined): boolean {
  if (!workspaceId) return true
  if (!m) return false
  return spansAllWorkspaces(m) || memberWorkspaceIds(m).includes(workspaceId)
}

export function filterMembersToWorkspace<T = any>(res: unknown, workspaceId: string | null | undefined): T[] {
  const anyRes = res as any
  const arr: any[] = Array.isArray(anyRes) ? anyRes
    : Array.isArray(anyRes?.data) ? anyRes.data
      : Array.isArray(anyRes?.data?.data) ? anyRes.data.data
        : Array.isArray(anyRes?.users) ? anyRes.users
          : []
  return arr.filter((m) => isWorkspaceMember(m, workspaceId)) as T[]
}
